// extracted by mini-css-extract-plugin
export default {"toggleTitle":"Capabilities_toggleTitle__aX2m5"};